import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import { Alert, Snackbar } from "@mui/material";
import { useState } from "react";
import UtilsFormule from "../../../utils/UtilsFormule";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import toastr from "toastr";

import getCurrentUserId from "../../../reduxSaga/sagas/requests/currentUserId";
import DiscountService from "../../../services/DiscountService";
const DataTablePromo = ({ listPromo }) => {
  const { SearchBar } = Search;
  const [openInfoAlert, setOpenInfoAlert] = useState(false);
  const [infoAlertText, setInfoAlertText] = useState();
  const [openDisable, setOpenDisable] = useState(false);
  const [openDisableDiscount, setOpenDisableDiscount] = useState(false);
  const [discountId, setDiscountId] = useState(false);

  const MyExportCSV = (props) => {
    const handleClick = () => {
      props.onExport();
    };
    return (
      <div>
        <button className="btn btn-dark" onClick={handleClick}>
          <i class="fas fa-download"></i> Télécharger CSV
        </button>
      </div>
    );
  };
  const handleInfoClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenInfoAlert(false);
  };
  const pageButtonRenderer = ({ page, active, onPageChange }) => {
    const handleClick = (e) => {
      e.preventDefault();
      onPageChange(page);
    };
    const activeStyle = active
      ? { backgroundColor: "black", color: "white" }
      : { backgroundColor: "white", color: "black" };
    return (
      <li className="page-item">
        <button
          className="btn btn-dark"
          onClick={handleClick}
          style={activeStyle}
        >
          {page}
        </button>
      </li>
    );
  };
  const options = {
    pageButtonRenderer,
  };

  function buttonTypeDiscountFormatter(cell, row) {
    if (row.typeDiscount === 1) {
      return <span>Promotion sur produit</span>;
    } else {
      <span>Promotion sur panier</span>;
    }
  }
  function buttonDCFormatter(cell, row) {
    return <span> {UtilsFormule.formatDate(row.creationDate)}</span>;
  }
  const handleCloseDisable = () => setOpenDisable(false);
  const handleCloseDisableDiscount = () => setOpenDisableDiscount(false);

  const handleOpenDiscountDisable = (idDiscount) => {
    setOpenDisableDiscount(true);
    setDiscountId(idDiscount);
  };
  function buttonDesactiverFormatter(cell, row) {
    return (
      <span>
        {" "}
        <button
          className="btn btn-secondary  mx-1"
          onClick={() => handleOpenDiscountDisable(row?.id)}
        >
          <h6>
            <small>
              {" "}
              <i class="fas fa-ban"></i>
            </small>
          </h6>
        </button>
      </span>
    );
  }
  const handleClickDiscountDisable = async () => {
    try {
      const response = await DiscountService.desactiverDiscount(
        getCurrentUserId(),
        discountId,
        0
      );
      toastr.success(response.data.success);
      handleCloseDisable();
      window.location.reload(true);
      // console.log("Carte Cadeau disabled successfully");
    } catch (error) {
      console.error("Error disabling Carte Cadeau:", error);
    }
  };
  const columns = [
    {
      dataField: "libelle",
      text: "Libellé",
      headerAlign: "center",
    },
    {
      dataField: "typeDiscount",
      text: "Type promotion",
      formatter: buttonTypeDiscountFormatter,

      headerAlign: "center",
    },
    {
      dataField: "creationDate",
      text: "DC",
      align: "center",
      headerAlign: "center",
      formatter: buttonDCFormatter,

      headerStyle: () => {
        return { width: "15%" };
      },
    },
    {
      dataField: "id",
      text: "Desactiver",
      align: "center",
      headerAlign: "center",
      formatter: buttonDesactiverFormatter,
      headerStyle: () => {
        return { width: "15%" };
      },
    },
  ];

  return (
    <div className="card">
      <div className="card-header">
        <h3 className="card-title">Les promtions actives disponible</h3>
      </div>
      <div className="card-body">
        <ToolkitProvider
          keyField="id"
          data={listPromo}
          columns={columns}
          exportCSV
          search
        >
          {(props) => (
            <div>
              <div className="row ml-0">
                <div>
                  <SearchBar
                    {...props.searchProps}
                    className="custome-search-field"
                    placeholder="Chercher"
                  />
                </div>
                <div className="ml-auto mr-0">
                  <MyExportCSV {...props.csvProps}></MyExportCSV>
                </div>
              </div>
              <div className="row">
                <BootstrapTable
                  {...props.baseProps}
                  pagination={paginationFactory(options)}
                  striped
                  hover
                  condensed
                />
              </div>
            </div>
          )}
        </ToolkitProvider>
      </div>
      {/* Include the QR Code Modal */}
      {openInfoAlert && (
        <Snackbar
          open={openInfoAlert}
          autoHideDuration={2000}
          onClose={handleInfoClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        >
          <Alert variant="filled" onClose={handleInfoClose} severity="info">
            {infoAlertText}
          </Alert>
        </Snackbar>
      )}
      <Dialog open={openDisableDiscount} onClose={handleCloseDisableDiscount}>
        <DialogTitle>Confirmation</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Voulez-vous désactiver cette promotion ?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDisableDiscount} color="primary">
            Annuler
          </Button>
          <Button onClick={handleClickDiscountDisable} color="error">
            Confirmer
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};
export default DataTablePromo;
